import { render, staticRenderFns } from "./PressRoomDetail.vue?vue&type=template&id=2d5916b0&"
import script from "./PressRoomDetail.vue?vue&type=script&lang=js&"
export * from "./PressRoomDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports